module.exports = __webpack_public_path__ + "static/media/bild1.b8a25cdf.png";